// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/ng-dialog/css/ngDialog-theme-default.css
// module id = G2Rh
// module chunks = 1 2